
<template>
    <BaseComponent name="catalog_description" v-if="catalog && catalog.description">
        <div v-html="catalog.description" class="mt-5 content content_styles table-responsive catalog_description"/>
    </BaseComponent>
</template>

<script setup>
defineProps({
    catalog: Object,
});
</script>
